import type { GlobalShortcutsItem } from '@atlassian/global-shortcuts/types';

import type { NavItemConfigInternal } from '../../types';

/**
 * Determines if there are any items that can be customized (reordered or hidden).
 * An item is customizable if:
 * - It can be reordered (isReorderable !== false), OR
 * - It can be hidden (isHideable !== false)
 *
 * Note: Shortcuts in global-shortcuts package do not have isReorderable/isHideable properties.
 * We only check NavItemConfigInternal items for customizability.
 */
export const hasCustomizableItems = (
	items: Record<string, NavItemConfigInternal>,
	_shortcuts: Record<string, GlobalShortcutsItem>,
): boolean => {
	// Check if any item is reorderable or hideable
	return Object.values(items).some(
		(item) => item.isReorderable !== false || item.isHideable !== false,
	);
};
